var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29984 1.79999C5.93583 1.79999 5.60765 2.01927 5.46835 2.35557C5.32905 2.69188 5.40605 3.07899 5.66345 3.33638L6.29984 3.97278V7.3544C6.29984 7.5931 6.20502 7.82202 6.03624 7.9908L2.43624 11.5908C0.735335 13.2917 1.93998 16.2 4.34543 16.2H13.6543C16.0597 16.2 17.2644 13.2917 15.5634 11.5908L11.9634 7.9908C11.7947 7.82202 11.6998 7.5931 11.6998 7.3544V3.97278L12.3362 3.33638C12.5936 3.07899 12.6706 2.69188 12.5313 2.35557C12.392 2.01927 12.0639 1.79999 11.6998 1.79999H6.29984ZM8.09984 7.3544V3.59999H9.89984V7.3544C9.89984 8.07049 10.1843 8.75724 10.6907 9.26359L11.6155 10.1884C10.9703 10.0383 10.2939 10.0687 9.66138 10.2795L9.23822 10.4206C8.49926 10.6669 7.70034 10.6669 6.96138 10.4206L6.45517 10.2518C6.4209 10.2404 6.38644 10.2301 6.35184 10.2208L7.30903 9.26359C7.81538 8.75724 8.09984 8.07049 8.09984 7.3544Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaker);
export default __webpack_public_path__ + "static/media/beaker.10fa0d231be433e5e1dcc4ae992d5658.svg";
export { ForwardRef as ReactComponent };